import React from 'react'
import styled from 'styled-components'

import { TableCell } from '../TableCell'

const TableDataElement = styled.td`
  height: 0; // fake height to make cell height work
  padding: 0;
`

export const TableData = ({
  type,
  getRowProps = () => {},
  getCellProps = () => {},
  getColumnProps = () => {},
  children,
  align = 'center',
  justify = 'left',
}) => (
    <TableDataElement className="table-data">
        <TableCell
            {...getRowProps()}
            {...getColumnProps()}
            {...getCellProps()}
            type={type}
            align={align}
            justify={justify}
            variant="body2"
        >
            {children}
        </TableCell>
    </TableDataElement>
)